import { useSearchParams } from 'react-router-dom';

function useGenerateParams() {
  const [searchParams] = useSearchParams();
  const childLicenseTypeCode = searchParams.get('licenseTypeCode');
  const parentId = searchParams.get('parentId');

  return {
    childLicenseTypeCode,
    parentId,
  };
}

export default useGenerateParams;
